// extracted by mini-css-extract-plugin
export default {"link":"Link-module__link","isPrimary":"Link-module__isPrimary"};